import Swiper from 'swiper';
import {add_swiper_class} from '@beziers/js/tools/swiper';

export default class Slider {

    constructor() {
        Slider.hero();
        Slider.slider_gutenberg_block();
        Slider.slider_related_post();
        Slider.slider_agenda_home();
        Slider.slider_home();
        Slider.slider_rencontre();
    }

    static hero() {
        const slider = '[data-id="wpiris-hero-slider"]',
            slider_wrapper = '[data-id="wpiris-hero-slider-wrapper"]',
            slider_item = '[data-id="wpiris-hero-slider-item"]';

        const hero_slider_pagination = new Swiper('.hero-slider-pagination', {
            slidesPerView: 'auto',
            touchRatio: 0,
            allowTouchMove: false
        });

        if ($(slider).length > 0) {

            add_swiper_class($(slider), $(slider_wrapper), $(slider_item));

            new Swiper($(slider), {
                mousewheel: {
                    forceToAxis: true,
                },
                autoplay: {},
                speed: 600,
                slidesPerView: 1,
                loop: true,
                lazy: true,
                thumbs: {
                    swiper: hero_slider_pagination,
                },
                pagination: {
                    el: '[data-trigger="swiper-dots"]',
                    clickable: true,
                },
            });
        }
    }

    static slider_gutenberg_block() {
        const slider = '[data-id="wpiris-block-slider"]',
            slider_wrapper = '[data-id="wpiris-block-slider-wrapper"]',
            slider_item = '[data-id="wpiris-block-slider-item"]';

        if ($(slider).length > 0) {

            add_swiper_class($(slider), $(slider_wrapper), $(slider_item));

            new Swiper($(slider), {
                keyboard: true,
                slidesPerView: 1,
                watchSlidesVisibility: true,
                spaceBetween: 10,
                speed: 600,
                pagination: {
                    el: '.swiperDots',
                    clickable: true,
                },
                breakpoints: {
                    1000: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    }
                }
            });
        }
    }

    static slider_related_post() {
        const slider = '[data-id="wpiris-relatedpost"]',
            slider_wrapper = '[data-id="wpiris-relatedpost-wrapper"]',
            slider_item = '[data-id="wpiris-relatedpost-item"]';

        if ($(slider).length > 0) {
            add_swiper_class($(slider), $(slider_wrapper), $(slider_item));

            new Swiper(slider, {
                keyboard: true,
                spaceBetween: 10,
                freeMode: true,
                speed: 600,
                slidesPerView: 2,
                watchSlidesVisibility: true,
                pagination: {
                    el: '.swiperDots',
                    clickable: true,
                },
                breakpoints: {
                    450: {
                        slidesPerView: 1,
                        spaceBetween: 10
                    },
                    750: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    },
                    1450: {
                        slidesPerView: 3,
                        spaceBetween: 40
                    }
                }
            });
        }
    }

    static slider_agenda_home() {
        const slider = '[data-id="wpiris-agenda"]',
            slider_wrapper = '[data-id="wpiris-agenda-wrapper"]',
            slider_item = '[data-id="wpiris-agenda-item"]';

        if ($(slider).length > 0) {

            add_swiper_class($(slider), $(slider_wrapper), $(slider_item));

            new Swiper($(slider), {
                keyboard: true,
                spaceBetween: 10,
                freeMode: true,
                watchSlidesVisibility: true,
                passiveListeners: false,
                observer: true,
                observeParents: true,
                speed: 600,
                slidesPerView: 1,
                breakpoints: {
                    370: {
                        slidesPerView: 1,
                        spaceBetween: 10
                    },
                    750: {
                        slidesPerView: 'auto',
                        spaceBetween: 20,
                    },
                    1000: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    1200: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    1450: {
                        slidesPerView: 2,
                        spaceBetween: 30
                    }
                }
            });
        }
    }

    static slider_home() {
        const slider = '[data-id="wpiris-sliderhome"]',
            slider_wrapper = '[data-id="wpiris-sliderhome-wrapper"]',
            slider_item = '[data-id="wpiris-sliderhome-item"]';

        if ($(slider).length > 0) {

            add_swiper_class($(slider), $(slider_wrapper), $(slider_item));

            new Swiper($(slider), {
                keyboard: true,
                spaceBetween: 10,
                freeMode: true,
                watchSlidesVisibility: true,
                passiveListeners: false,
                observer: true,
                observeParents: true,
                speed: 600,
                slidesPerView: 1,
                pagination: {
                    el: '.swiperDots',
                    type: 'bullets',
                    clickable: true,
                },
            });
        }
    }

    static slider_rencontre() {
        const slider = '[data-id="wpiris-rencontre"]',
            slider_wrapper = '[data-id="wpiris-rencontre-wrapper"]',
            slider_item = '[data-id="wpiris-rencontre-item"]';

        if ($(slider).length > 0) {

            add_swiper_class($(slider), $(slider_wrapper), $(slider_item));

            new Swiper($(slider), {
                keyboard: true,
                spaceBetween: 10,
                freeMode: true,
                watchSlidesVisibility: true,
                passiveListeners: false,
                observer: true,
                observeParents: true,
                speed: 600,
                slidesPerView: 1,
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        spaceBetween: 20
                    },
                    750: {
                        slidesPerView: 1,
                        spaceBetween: 20
                    },
                }
            });
        }
    }
}